export default class ModalHtml {
  openModalButton;
  modalNode;
  modalInnerNode;
  backdropNode;
  closeIconNode;
  toggleModal;
  modalContent;
  modalName;
  constructor(openModalButton, modalNode, modalInnerNode, backdropNode, closeIconNode) {
    this.openModalButton = openModalButton;
    this.modalNode = modalNode;
    this.modalInnerNode = modalInnerNode;
    this.backdropNode = backdropNode;
    this.closeIconNode = closeIconNode;
    let dataContentId = this.openModalButton.getAttribute('data-content');
    this.modalName = this.openModalButton.getAttribute('data-name') ? this.openModalButton.getAttribute('data-name') : '';
    if (dataContentId && document.getElementById(dataContentId)) {
      this.modalContent = document.getElementById(dataContentId).innerHTML;
      this.bindListeners();
    }
  }

  bindListeners() {
    this.openModalButton.addEventListener('click', this.open.bind(this));
    this.backdropNode.addEventListener('click', this.close.bind(this));
    this.closeIconNode.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.modalNode.setAttribute('data-name', this.modalName);
    this.modalInnerNode.innerHTML = this.modalContent;
    this.modalNode.classList.add('open');
    this.backdropNode.classList.add('open');
    if (this.modalName === 'recipes-filter') { 
      let ev = new CustomEvent('recipes-filter.open', {
        'detail': {
          'contentId': this.openModalButton.getAttribute('data-content'), 
          'modalInstance': this
        }
      });
      document.dispatchEvent(ev);
    }
  }

  close() {
    this.modalNode.classList.remove('open');
    this.backdropNode.classList.remove('open');
    this.modalInnerNode.innerHTML = '';
  }
}




// WEBPACK FOOTER //
// ./ui/assets/js/Modal/ModalHtml.js